import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/forms/Buttons/Button";
import { HomeIcon } from "@heroicons/react/24/outline";

export default function NotFound() {
  const [t] = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sheet flex items-center justify-center px-4">
      <div className="text-center max-w-md w-full">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t("not_found.title")}
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            {t("not_found.message")}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            Icon={HomeIcon}
            text={t("not_found.go_home")}
            color="primary"
            onClick={() => navigate("/")}
            className="w-full sm:w-auto"
          />
          <Button
            text={t("welcome.login")}
            color="secondary"
            onClick={() => navigate("/login")}
            className="w-full sm:w-auto"
          />
        </div>
      </div>
    </div>
  );
}
